import { jsx, jsxs } from "react/jsx-runtime";
import { PromptInputSpeechButton } from "../../../ai-elements/prompt-input.js";
import { IconMicrophone } from "../ConciergeIcons.js";
const MicrophoneButton = ({
  disabled,
  textareaRef,
  onChange,
  styles,
  themeIcons,
  resolveColor
}) => {
  const micIconKey = styles.microphoneIcon;
  const customMicIcon = micIconKey && micIconKey !== "default" ? themeIcons[micIconKey] : null;
  return /* @__PURE__ */ jsx(
    PromptInputSpeechButton,
    {
      disabled,
      textareaRef,
      onTranscriptionChange: onChange,
      "aria-label": "Voice input",
      className: "tw:p-0 tw:bg-transparent! tw:shadow-none! tw:border-none tw:cursor-pointer hover:tw:bg-transparent! disabled:tw:opacity-50 disabled:tw:cursor-not-allowed",
      style: { width: styles.iconSize, height: styles.iconSize },
      children: (isListening) => /* @__PURE__ */ jsxs("div", { className: "tw:relative tw:cursor-pointer", children: [
        customMicIcon ? /* @__PURE__ */ jsx(
          "img",
          {
            src: customMicIcon.url,
            alt: customMicIcon.name,
            style: {
              width: styles.iconSize,
              height: styles.iconSize,
              filter: isListening ? `drop-shadow(0 0 2px ${resolveColor(styles.micActiveColor)})` : void 0
            }
          }
        ) : /* @__PURE__ */ jsx(
          IconMicrophone,
          {
            size: styles.iconSize,
            style: {
              color: isListening ? resolveColor(styles.micActiveColor) : resolveColor(styles.iconColor),
              width: styles.iconSize,
              height: styles.iconSize
            }
          }
        ),
        isListening && /* @__PURE__ */ jsx(
          "span",
          {
            className: "tw:absolute tw:-top-0.5 tw:-right-0.5 tw:size-2 tw:rounded-full tw:animate-pulse",
            style: { backgroundColor: resolveColor(styles.micActiveColor) }
          }
        )
      ] })
    }
  );
};
export {
  MicrophoneButton
};
//# sourceMappingURL=MicrophoneButton.js.map
